module.exports = __webpack_public_path__ + "fonts/e22078ca574c089ecbe056c281fdeae8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/img/vehicle.svg
// module id = 285
// module chunks = 0